var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"value":_vm.period,"items":_vm.periods,"item-text":"title","return-object":"","hide-details":"","placeholder":"Período","menu-props":{ offsetY: true, bottom: true },"dense":""},on:{"change":_vm.setPeriod}})
}
var staticRenderFns = []

export { render, staticRenderFns }